import * as ToastPrimitive from '@radix-ui/react-toast'
import { AnimatePresence, motion } from 'framer-motion'
import React from 'react'
import styled from 'styled-components'

const StyledToastViewport = styled(ToastPrimitive.Viewport)`
  display: flex;
  position: fixed;
  bottom: 10px;
  left: 50%;
  transform: translate(-50%, 0);
  flex-direction: column;
  padding: 25px;
  gap: 10px;
  width: 450px;
  max-width: 100vw;
  margin: 0;
  list-style: none;
  z-index: 99999999;
  outline: none;
`
const StyledToastRoot = styled(ToastPrimitive.Root)`
  background-color: #000000;
  border-radius: 0.25rem;
  padding: 15px;
  width: 450px;
  position: absolute;
  bottom: 10px;
  left: 10px;
  grid-template-areas: 'title close' 'description close';
  grid-template-columns: auto max-content;
  column-gap: 15px;
  align-items: center;
  list-style: none;
  display: grid;
  box-shadow: 0 2px 10px ${({ theme }) => theme.forecast.background1};
`

const StyledToastTitle = styled(ToastPrimitive.Title)`
  margin-bottom: 5px;
  font-weight: 500;
  color: #ffffff;
  font-size: 15px;
  grid-area: title;
`

const StyledToastDescription = styled(ToastPrimitive.Description)`
  margin: 0;
  color: #ffffff;
  font-size: 13px;
  line-height: 1.3;
  grid-area: description;
`

export const Toast: React.FC<{
  title: string
  message: string
  open: boolean
  setOpen?: React.Dispatch<React.SetStateAction<boolean>>
  duration?: number
}> = ({ title, message, open, setOpen, duration }) => {
  //---------------------------------------------------------------------

  return (
    <ToastPrimitive.Provider>
      <AnimatePresence>
        {open ? (
          <StyledToastRoot
            open={open}
            onOpenChange={setOpen}
            duration={duration}>
            <motion.div
              initial={{ opacity: 0, y: 50, scale: 0.3 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 20, scale: 0.5 }}>
              <StyledToastTitle>{title}</StyledToastTitle>
              <StyledToastDescription>{message}</StyledToastDescription>
            </motion.div>
          </StyledToastRoot>
        ) : null}
      </AnimatePresence>
      <StyledToastViewport />
    </ToastPrimitive.Provider>
  )
}
